import { Box } from "@mui/material";
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { CustomerContext } from "./Context/CustomerContext";

const customerOption = [
  {
    name: `Đơn hàng`,
    slug: `order`,
  },
  {
    name: `Tài khoản`,
    slug: `edit-account`,
  },
  // {
  //   name: `Điểm của tôi`,
  //   slug: ``,
  // },
];

const CustomerDashboard = () => {
  const { customerData } = useContext(CustomerContext);

  return (
    <Box>
      <Box sx={{ pb: 3 }}>
        Xin chào <b>{customerData.visibleName}</b>
      </Box>
      <div className="paragraph">
        Từ trang quản lý tài khoản bạn có thể xem{" "}
        <Link to={`order`}>đơn hàng mới</Link>{" "}
        và <Link to={`edit-account`}>sửa mật khẩu và thông tin tài khoản</Link>.
      </div>
      <div className="customer-dashboard-button-layout">
        {customerOption.map((item, idx) => (
          <Link to={item.slug} key={idx}>
            <div className="customer-dashboard-button-item">{item.name}</div>
          </Link>
        ))}
      </div>
    </Box>
  );
};

export default CustomerDashboard;
